var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGag = function SvgGag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 33,
    height: 36,
    viewBox: "0 0 1.3 1.41",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2312516123040"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M.52.11c.46-.09.77.29.6.69-.08.2-.23.42-.39.5C.57 1.38.18.96.15.66.12.37.23.17.52.11z",
    stroke: "#000",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27.84c0 .09-.01.2-.02.27 0 .01-.21.02-.46.02.05-.04.08-.1.08-.17C.87.91.85.87.83.83c.22.01.4.02.44.01zm-.76.29c-.2 0-.37-.01-.44-.02C.06 1.11.03.79.04.79.07.8.27.8.49.81.45.85.43.9.43.96c0 .07.03.13.08.17z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 0.65,
    cy: 0.96,
    r: 0.22,
    stroke: "#000",
    strokeWidth: 0.2,
    strokeMiterlimit: 22.9256
  })))));
};

export default SvgGag;